/* eslint-disable react/function-component-definition */
/* eslint-disable no-use-before-define */
import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Card, CardContent, Grid, Typography } from '@mui/material';
import { yellow } from '@mui/material/colors';
import GroupsIcon from '@mui/icons-material/Groups';

const TotalTeams: FC<React.PropsWithChildren<any>> = ({
  className,
  ...rest
}) => {
  return (
    <Card
      style={{
        height: '100%',
        borderRadius: '5px'
      }}
      {...rest}
    >
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item md={9}>
            <Typography color="textSecondary" gutterBottom variant="h6">
              Students
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {0}
            </Typography>
          </Grid>
          <Grid item md={3}>
            <Avatar
              style={{
                backgroundColor: yellow[600],
                height: 46,
                width: 46
              }}
            >
              <GroupsIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

TotalTeams.propTypes = {
  className: PropTypes.string
};

export default TotalTeams;
